import React, { useEffect, useState } from "react";
import { Box, Button, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { getDownloadURL, ref } from "firebase/storage";
import { useHistory } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import { db, storage } from "../Config/firebase";
import { consultaTenantAtual } from "../Utils/tenant";

function formatarData(data) {
  if (!data || !/^\d{4}-\d{2}-\d{2}$/.test(data)) return "-";
  const [ano, mes, dia] = data.split("-");
  return `${dia}/${mes}/${ano}`;
}

export default function ListaCalibracoesExternasPrensa() {
  const [calibracoes, setCalibracoes] = useState([]);
  const [pesquisa, setPesquisa] = useState("");
  const history = useHistory();

  useEffect(() => {
    getDocs(consultaTenantAtual(collection(db, "tblCalibracoesExternasPrensa"))).then((snap) => {
      setCalibracoes(snap.docs.map((item) => ({ id: item.id, ...item.data() }))
        .sort((a, b) => String(b.dataCalibracao || "").localeCompare(String(a.dataCalibracao || ""))));
    });
  }, []);

  const texto = pesquisa.trim().toLowerCase();
  const lista = calibracoes.filter((item) =>
    !texto || [item.numeroCertificado, item.descricaoEquipamento].some((valor) =>
      String(valor || "").toLowerCase().includes(texto)
    )
  );

  async function abrirCertificado(event, item) {
    event.stopPropagation();
    const arquivo = item.arquivoCertificado;
    if (!arquivo?.url && !arquivo?.storagePath) return;
    const url = arquivo.url || await getDownloadURL(ref(storage, arquivo.storagePath));
    window.open(url, "_blank", "noopener,noreferrer");
  }

  return <>
    <Navbar />
    <Box sx={{ p: 4 }}>
      <Paper className="cabecalho-lista-cadastro" elevation={0} sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" fontWeight={700}>Calibração Externa de Prensa</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>Certificados emitidos por empresas externas</Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button variant="contained" onClick={() => history.push("/app/calibracao-prensa-externa/novo")}>+ Nova calibração externa</Button>
          <TextField size="small" label="Pesquisar" value={pesquisa} onChange={(e) => setPesquisa(e.target.value)} sx={{ flex: 1 }} />
        </Box>
      </Paper>
      <Paper>
        <Table className="lista-cadastro-padrao" size="small">
          <TableHead><TableRow><TableCell>Certificado</TableCell><TableCell>Descrição do equipamento</TableCell><TableCell>Data de calibração</TableCell><TableCell>Data de vencimento</TableCell><TableCell>Arquivo</TableCell></TableRow></TableHead>
          <TableBody>{lista.map((item) => <TableRow hover key={item.id} sx={{ cursor: "pointer" }} onClick={() => history.push(`/app/calibracao-prensa-externa/${item.id}`)}>
            <TableCell>{item.numeroCertificado || "-"}</TableCell><TableCell>{item.descricaoEquipamento || "-"}</TableCell><TableCell>{formatarData(item.dataCalibracao)}</TableCell><TableCell>{formatarData(item.dataVencimento)}</TableCell><TableCell>{item.arquivoCertificado?.storagePath || item.arquivoCertificado?.url ? <Button size="small" onClick={(event) => abrirCertificado(event, item)}>Abrir certificado</Button> : "Não anexado"}</TableCell>
          </TableRow>)}</TableBody>
        </Table>
      </Paper>
    </Box>
  </>;
}
